export const API_DATE_FORMAT = 'DD/MM/YYYY';
export const VOUCHER_EXPIRED_AT_FORMAT = 'DD MMMM';
export const DISPLAY_DATE_FORMAT = 'DD MMM, YYYY';
export const DISPLAY_DATE_TIME_FORMAT = 'DD MMM, YYYY HH:mm';
export const API_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
